import { Toast } from "components/ToastShow/ToastAlert";

import { useEffect, useState } from "react";
import { trans, uuidv4 } from "utils/helpers";

import { Button } from "components/Button/Button";
import { DataGrid } from "components/DataGrid/DataGrid";
import { DictionarySelectBox } from "components/DictionaryTypeSelect/DictionaryTypeSelect";
import { Message } from "components/Message/Message";
import { Person } from "components/Person/Person";
import { GUID_EMPTY, INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { MessageType } from "types/enum";
import { Textbox } from "components/Textbox/Textbox";
import { AutoCompleteDictionary } from "components/AutoCompleteDictionary/AutoCompleteDictionary";

interface RelatedItemFormPropsType {
  ItemRelationsCallBack: (e) => void;
  mode: any;
  ItemRelations: any;
  ItemId?: string;
}
export const RelatedItemForm = ({
  ItemRelationsCallBack,
  mode,
  ItemRelations,
  ItemId,
}: RelatedItemFormPropsType) => {
  const [resetForm, setResetForm] = useState(false);
  const [userChanges, setUserChanges] = useState({});
  const [selectedObj, setSelectedObj] = useState<any>(null);
  const [editForm, setEditForm] = useState<any>({});
  const [indexEditForm, setIndexEditForm] = useState<number>(0);
  const [relatedMode, setRelatedMode] = useState<"create" | "edit">("create");
  const [relatedList, setRelatedList] = useState<any>(ItemRelations);
  const [Item, setItem] = useState<any>();
  const [relationType, setRelationType] = useState<any>();

  const handleDeleteRow = async (id: string = selectedObj.Id) => {
    const filteredData=relatedList.filter((item) => item.Id != id)
    setRelatedList(filteredData);
    ItemRelationsCallBack(filteredData);
  };


  const handleEdit = (id) => {
    relatedList.map((item, index) => {
      if (item.Id == id) {
        setEditForm(item);
        setIndexEditForm(index);
      }
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    let data: any = {};
    data = {
      Id: relatedMode == "create" ? uuidv4() : editForm.Id,
      ItemId: ItemId?ItemId:GUID_EMPTY,
      ItemRelatedId: event.target.ItemRelatedId?.value,
      ItemRelationTypeId: event.target.ItemRelationTypeId?.value,
      ItemRelated: Item.Name,
      ItemRelationType: relationType.Name,
      "Description": event.target.Description?.value,
      "DescriptionEN": event.target.DescriptionEN?.value,
    };

    if (relatedMode == "create") {
      setRelatedList([...relatedList, data]);
      ItemRelationsCallBack([...relatedList, data]);
    } else {
      let newRelated = JSON.parse(JSON.stringify(relatedList));
      newRelated.splice(indexEditForm, 1, data);
      ItemRelationsCallBack(newRelated);
      setRelatedList(newRelated);
    }
    setResetForm(true);
    setResetForm(true);
  };


  const handleBeforeUnload = (event) => {
    event.preventDefault();
    event.returnValue = "";
  };

  useEffect(() => {
    if (Object.values(userChanges).filter((item) => item != null).length > 0) {
      sessionStorage.setItem("changingforms", "true");
      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    } else {
      sessionStorage.setItem("changingforms", "false");
      window.removeEventListener("beforeunload", handleBeforeUnload);
    }
  }, [userChanges]);
  useEffect(() => {
    if (resetForm) {
      setResetForm(false);
    }
  }, [resetForm]);



  useEffect(() => {
    if(ItemRelations && ItemRelations.length > 0){
        ItemRelationsCallBack(ItemRelations);
        setRelatedList(ItemRelations);
    }
  },[ItemRelations])

  return (
    <>
      {mode != "view" && (
        <div className="card">
          <form className="TypeSettingForm  card-body" onSubmit={handleSubmit}>
            <div className="row my-1">
              <div className="col-12 col-sm-3 ">
                <AutoCompleteDictionary
                  returnObj={true}
                  required={true}
                  className={ "text-box"}
                  name={"ItemRelatedId"}
                  label={"Item"}
                  baseUrl={INVENTORYANDSALES_URL}
                  url={ENDPOINTSINVENTORYANDSALES.Inventory.ItemApis.ItemTree.Dictionary}
                  value={editForm?.ItemRelatedId??''}
                  onChange={(e) => {
                    setItem(e);
                  }}
                  mode={mode}
                  
                />
              </div>
              <div className="col-12 col-sm-3 ">
                <DictionarySelectBox
                  value={editForm?.ItemRelationTypeId??''}
                  required={true}
                  baseUrl={INVENTORYANDSALES_URL}
                  endPoint={
                    ENDPOINTSINVENTORYANDSALES.Inventory.BaseDefinitionAndSettingApi.ItemRelationType.dictionary
                  }
                  label="ItemRelationType"
                  name="ItemRelationTypeId"
                  resetForm={resetForm}
                  onChange={(e, obj) => {
                    setRelationType(obj);
                  }}
                />
              </div>
              <div className="col-2">
                <Textbox
                    textboxType="text"
                    textboxName="Description"
                    resetForm={resetForm}
                    defaultValue={editForm?.Description ? editForm.Description : null}
                    labelText="Description"
                    mode={mode}
                    />
               </div>
                <div className="col-2">
                  <Textbox
                      textboxType="text"
                      textboxName="DescriptionEN"
                      resetForm={resetForm}
                      defaultValue={editForm?.DescriptionEN ? editForm.DescriptionEN : null}
                      labelText="DescriptionEN"
                      mode={mode}
                      />
               </div>
            </div>
            {relatedMode == "create" ? (
              <Button value="Save" btnType="submit" />
            ) : (
              <>
                <Button value="Save" btnType="submit" />
                <Button
                  value="cancel"
                  btnType="cancel"
                  onClick={() => {
                    setEditForm(null);
                    setRelatedMode("create");
                    setResetForm(true)
                  }}
                />
              </>
            )}
          </form>
        </div>
      )}
      <div className="card card-body">
        {relatedList?.length > 0 ? (
          <>
            <DataGrid
              parentName={"RelatedItem"}
              theadData={Object.keys(relatedList[0])}
              tbodyData={relatedList}
              scrollHeight={"67vh"}
              startIndex={4}
              minCellWidth={80}
              selectedRowObjectCallback={setSelectedObj}
              handleDelete={(e) => {
                // Toast(trans("msg_deleteconfirm"), "warning", "alert", () =>
                //   handleDeleteRow(e)
                // );
                Toast(trans("msg_deleteconfirm"), MessageType.confirmDelete, () =>
                  handleDeleteRow(e)
                );
              }}
              handleEdit={(e) => {
                handleEdit(e);
                setRelatedMode("edit");
              }}
            />
          </>
        ) : (
          <Message message={"NoDataForPreview"} type={"info"} />
        )}
      </div>
    </>
  );
};
